import { render, staticRenderFns } from "./InventoryHistoryDetail.vue?vue&type=template&id=2a0929b0&"
import script from "./InventoryHistoryDetail.vue?vue&type=script&lang=js&"
export * from "./InventoryHistoryDetail.vue?vue&type=script&lang=js&"
import style0 from "./InventoryHistoryDetail.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports